import React, { useState } from 'react';
import { CheckCircle, ArrowRight, Mail, Send } from 'lucide-react';
import { motion } from 'framer-motion';
import { Stagger, Item, Reveal } from './motion';

export const Contact = () => {
  const [formState, setFormState] = useState({ submitting: false, succeeded: false });
  const [newsletterState, setNewsletterState] = useState({ submitting: false, succeeded: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState({ submitting: true, succeeded: false });

    const formData = new FormData(e.target);
    formData.append('access_key', '05bd11d3-7807-4b6b-9610-029ddd6b7f75');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (result.success) {
        setFormState({ submitting: false, succeeded: true });
        e.target.reset();
      } else {
        setFormState({ submitting: false, succeeded: false });
        alert('A apărut o eroare. Încearcă din nou.');
      }
    } catch (error) {
      setFormState({ submitting: false, succeeded: false });
      alert('A apărut o eroare. Încearcă din nou.');
    }
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterState({ submitting: true, succeeded: false });

    const email = e.target.EMAIL.value;
    const formData = new FormData();
    formData.append('EMAIL', email);
    formData.append('b_36842a890cae8b81ed074afe1_8eb76abb3f', ''); // honeypot

    try {
      // Use Mailchimp's post-json endpoint
      const url = 'https://polytooldesign.us21.list-manage.com/subscribe/post-json?u=36842a890cae8b81ed074afe1&id=8eb76abb3f&f_id=00f4ffe6f0&EMAIL=' + encodeURIComponent(email);

      // JSONP approach for cross-origin
      const script = document.createElement('script');
      script.src = url + '&c=mailchimpCallback';

      window.mailchimpCallback = (response) => {
        if (response.result === 'success') {
          setNewsletterState({ submitting: false, succeeded: true });
          e.target.reset();
        } else {
          setNewsletterState({ submitting: false, succeeded: false });
          alert(response.msg || 'A apărut o eroare. Încearcă din nou.');
        }
        delete window.mailchimpCallback;
        script.remove();
      };

      document.body.appendChild(script);
    } catch (error) {
      setNewsletterState({ submitting: false, succeeded: false });
      alert('A apărut o eroare. Încearcă din nou.');
    }
  };

  return (
    <section id="contact" className="section glow-copper">
      <div className="container">
        <div style={{ maxWidth: '36rem', margin: '0 auto' }}>
          <Stagger className="center" style={{ marginBottom: '3rem' }}>
            <Item as="h2" className="hm-h2">Hai să discutăm.</Item>
            <Item as="p" className="hm-sub">
              Vrei o demonstrație, ai o întrebare despre unul dintre produse sau te înscrii pe
              lista de așteptare pentru Plicuri? Scrie-ne și îți răspundem.
            </Item>
          </Stagger>

          <Reveal delay={0.1}>
            {formState.succeeded ? (
              <div className="glass-panel" style={{ padding: '3rem', textAlign: 'center' }}>
                <CheckCircle size={28} style={{ color: '#22c55e', marginBottom: '1rem' }} />
                <h3 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.25rem' }}>
                  Mesaj trimis.
                </h3>
                <p style={{ color: 'var(--text-tertiary)', fontSize: '0.875rem' }}>
                  Te contactăm în curând.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <input type="hidden" name="subject" value="Mesaj nou de pe polytooldesign.com" />
                <div className="form-grid">
                  <div>
                    <label className="label" htmlFor="name">Nume</label>
                    <input type="text" id="name" name="name" required className="input" placeholder="Numele tău" autoComplete="name" />
                  </div>
                  <div>
                    <label className="label" htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" required className="input" placeholder="nume@companie.ro" autoComplete="email" />
                  </div>
                </div>

                <div style={{ marginTop: '1rem' }}>
                  <label className="label" htmlFor="message">Mesaj</label>
                  <textarea id="message" name="message" rows="4" required className="input" placeholder="Spune-ne despre ce ai nevoie..." />
                </div>

                <div style={{
                  marginTop: '1.25rem',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <a
                    href="mailto:contact@polytooldesign.com"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.375rem',
                      fontSize: '0.875rem',
                      color: 'var(--text-muted)',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = 'var(--copper)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}
                  >
                    <Mail size={14} />
                    contact@polytooldesign.com
                  </a>
                  <motion.button
                    type="submit"
                    disabled={formState.submitting}
                    className="btn btn-copper"
                    whileHover={{ scale: 1.035 }}
                    whileTap={{ scale: 0.97 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 18 }}
                  >
                    {formState.submitting ? 'Se trimite...' : 'Trimite mesajul'}
                    {!formState.submitting && <ArrowRight size={14} />}
                  </motion.button>
                </div>
              </form>
            )}
          </Reveal>

          {/* Newsletter */}
          <Reveal delay={0.18} style={{ marginTop: '4rem', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.0625rem', fontWeight: 600, marginBottom: '0.375rem' }}>Newsletter</h3>
            <p style={{ color: 'var(--text-tertiary)', fontSize: '0.875rem', marginBottom: '1.25rem' }}>
              Noutăți despre produsele Poly Tool și despre legal tech.
            </p>

            {newsletterState.succeeded ? (
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem',
                padding: '0.625rem 1rem',
                borderRadius: '8px',
                border: '1px solid rgba(34, 197, 94, 0.2)',
                color: '#22c55e',
                fontSize: '0.8125rem'
              }}>
                <CheckCircle size={14} />
                Abonat cu succes.
              </div>
            ) : (
              <form onSubmit={handleNewsletterSubmit} className="newsletter-form" style={{ margin: '0 auto' }}>
                <input
                  type="email"
                  name="EMAIL"
                  required
                  placeholder="Adresa ta de email"
                  className="newsletter-input"
                  autoComplete="email"
                />
                <button type="submit" disabled={newsletterState.submitting} className="newsletter-btn" aria-label="Abonare newsletter">
                  <Send size={13} />
                </button>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
